import { render, staticRenderFns } from "./supplierRefund.vue?vue&type=template&id=23f69252&"
import script from "./supplierRefund.vue?vue&type=script&lang=js&"
export * from "./supplierRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports